export const CommonEventRegistrationCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Event Manager',
    path: '/sistema',
  },
  {
    name: 'Iscrizione Evento',
    path: '/sistema/eventmanager/iscrizione-evento',
  },
];
